export default (state = [], action) => {
    switch (action.type) {
        case 'OPTIONS_FETCH_SUCCESS':
            return action.options;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/optionReducers.js